import { render, staticRenderFns } from "./VideosWrapper.vue?vue&type=template&id=1ba1dcd7&scoped=true&"
import script from "./VideosWrapper.vue?vue&type=script&lang=js&"
export * from "./VideosWrapper.vue?vue&type=script&lang=js&"
import style0 from "./VideosWrapper.vue?vue&type=style&index=0&id=1ba1dcd7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ba1dcd7",
  null
  
)

export default component.exports